import Constants from "./Constants";

// Admin-authored page content (TinyMCE) stores uploaded images as paths relative
// to the admin app's own wwwroot (e.g. "/uploads/x.webp"), since that's where the
// files physically live. Rewriting them to absolute URLs here - rather than
// relying on the admin editor to bake in an absolute URL at save time - means
// every page renders correctly regardless of which admin domain authored it or
// when it was saved, with no separate data migration needed for older content.
export function absolutizeImageSrcs(html) {
    if (!html) return html;
    const host = Constants.IMAGE_URL;
    return html.replace(/(<img\b[^>]*?\bsrc=)(["'])\/(?!\/)/gi, `$1$2${host}/`);
}
